import React from 'react';
import ManageOrders from '.';
import CreateOrder from './createOrder';
import ManageOrdersParams from '././parameters';
import {paths} from '../../common/dictionaries/urls';
import ShowManageOrder from './showOrder';

export const manageOrdersRoutes = [
  {'component': <ManageOrdersParams />, 'path': paths.ParamsManageOrders},
  {'component': <CreateOrder />, 'path': paths.CreateManageOrders},
  {'component': <ManageOrders />, 'path': paths.ManageOrders},
  {'component': <ShowManageOrder />, 'path': paths.ShowManageOrder},
];
